module.exports = __webpack_public_path__ + "img/Lobby_Video.ff96c305.jpg";